import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useGetPageElementsQuery } from '../../../api/pageElementApiSlice';
import Block from '../../../components/Block';
import Pagination from '../../../components/tables/Pagination';
import Table from '../../../components/tables/Table';
import { TableSearchRow } from '../../../components/tables/TableSearch';
import useCustomTable from '../../../components/tables/useCustomTable';
import Title from '../../../components/Title';

const PageElementList = () => {
  const {data, isLoading, isSuccess} = useGetPageElementsQuery()
  const { t } = useTranslation();
  const history = useHistory();

  const columns = [{
    Header: t("pageElement.name"),
    accessor: 'name'
  },{
    Header: t("pageElement.label"),
    accessor: 'label'
  },{
    Header: t("pageElement.translate"),
    accessor: 'count',
  }];

  const tableOptions = {
    sortable: true,
    paginate: true
  };

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    tableFilterProps,
  } = useCustomTable(tableOptions)


  const showPageElement = (data) => history.push(`/page_elements/${data.id}`)

  if ( !isSuccess ) { return(<></>) }

  return ( <>
    <Title main={t("pageElement.index")}/>
    <TableSearchRow {...tableSearchProps}/>
    <Block className="mb-0">
      <Table
        data={data}
        columns={columns}
        onRowClick={showPageElement}
        {...tableProps} />
    </Block>
    <Pagination {...paginationProps}/>
  </> );
}

export default PageElementList;